const CACHE = new Map();
const SCHEMA_TTL = 5 * 60 * 1000;
const RESPONSE_TTL = 2 * 60 * 1000;

export async function getCachedSchema(firestore, collectionName, loader) {
  const key = `schema:${collectionName}`;
  const hit = CACHE.get(key);
  if (hit && Date.now() - hit.at < SCHEMA_TTL) return hit.value;
  const { analyzeCollectionSchema } = await import("./aiSchemaService");
  const value = await analyzeCollectionSchema(firestore, collectionName);
  CACHE.set(key, { value, at: Date.now() });
  return value;
}

export function getCachedResponse(promptKey) {
  const hit = CACHE.get(`resp:${promptKey}`);
  if (hit && Date.now() - hit.at < RESPONSE_TTL) return hit.value;
  return null;
}

export function setCachedResponse(promptKey, value) {
  CACHE.set(`resp:${promptKey}`, { value, at: Date.now() });
}

export function getCachedCollections(key) {
  const hit = CACHE.get(`cols:${key}`);
  if (hit && Date.now() - hit.at < SCHEMA_TTL) return hit.value;
  return null;
}

export function setCachedCollections(key, value) {
  CACHE.set(`cols:${key}`, { value, at: Date.now() });
}

export function clearAiCache() {
  CACHE.clear();
}
